var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pl-2"},[_vm._v(_vm._s(_vm.displayText))])
}
var staticRenderFns = []

export { render, staticRenderFns }